<template>
  <div>
    <div>
      <b-row
        align-h="center"
        class="b-tabs"
      >
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(0)"
            @click="didSelect(0)"
          >云服务</label>
        </b-col>
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(1)"
            @click="didSelect(1)"
          >本地版</label>
        </b-col>
        <b-col
          cols="2"
          class="text-center"
        >
          <label
            :class="linkClass(2)"
            @click="didSelect(2)"
          >定制化</label>
        </b-col>
      </b-row>
    </div>
    <b-container>
      <div
        class="div-content"
        v-if="show === 0"
      >
        <b-row align-h="center">
          <b-col cols="6">
            <img
              class="content-ico"
              src="@/assets/images/solution-content-ico_1.png"
            >
            <p class="content-title text-center">云服务版本系统构建</p>
            <img
              class="content-img"
              src="@/assets/images/solution-content-img.png"
            >
            <p class="content-desc">针对数据安全要求较高的客户，在内部服务器构建玩转工厂APP使用环境，运营数据保存在客户本地，满足客户对数据安全的最高要求。同时可以辅助终端硬件如PDA(手持终端）、工业PAD、大屏幕等实现异常停线（Andon）、故障报修，安全风险、发货管理、维护保养、物料管理、绩效指标管理等更便捷的操作和可视化。</p>
          </b-col>
        </b-row>
      </div>
      <div
        class="div-content"
        v-if="show === 1"
      >
        <b-row align-h="center">
          <b-col cols="6">
            <img
              class="content-ico"
              src="@/assets/images/solution-content-ico_2.png"
            >
            <p class="content-title text-center">本地版本系统构建</p>
            <img
              class="content-img"
              src="@/assets/images/solution-content-img.png"
            >
            <p class="content-desc">针对数据安全要求较高的客户，在内部服务器构建玩转工厂APP使用环境，运营数据保存在客户本地，满足客户对数据安全的最高要求。同时可以辅助终端硬件如PDA(手持终端）、工业PAD、大屏幕等实现异常停线（Andon）、故障报修，安全风险、发货管理、维护保养、物料管理、绩效指标管理等更便捷的操作和可视化。</p>
          </b-col>
        </b-row>
      </div>
      <div
        class="div-content"
        v-if="show === 2"
      >
        <b-row align-h="center">
          <b-col cols="6">
            <img
              class="content-ico"
              src="@/assets/images/solution-content-ico_3.png"
            >
            <p class="content-title text-center">定制版本系统构建</p>
            <img
              class="content-img"
              src="@/assets/images/solution-content-img.png"
            >
            <p class="content-desc">针对数据安全要求较高的客户，在内部服务器构建玩转工厂APP使用环境，运营数据保存在客户本地，满足客户对数据安全的最高要求。同时可以辅助终端硬件如PDA(手持终端）、工业PAD、大屏幕等实现异常停线（Andon）、故障报修，安全风险、发货管理、维护保养、物料管理、绩效指标管理等更便捷的操作和可视化。</p>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "SolutionContent",
  data() {
    return {
      show: 1,
    };
  },
  methods: {
    didSelect(ids) {
      this.show = ids;
    },
    linkClass(idx) {
      if (this.show === idx) {
        return ["label-did"];
      } else {
        return ["label"];
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.b-tabs {
  box-shadow: 0rem 0.3rem 0.8rem 0rem rgba(2, 0, 0, 0.11);
  padding-top: 2rem;
  padding-bottom: 2rem;

  .label-did {
    color: #12b7f6;
    font-size: 1.3rem;
  }

  .label {
    color: #333333;
    font-size: 1.3rem;
  }
}

.content-ico {
  height: 5.6rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  margin-left: 50%;
  transform: translateX(-50%);
}

.content-title {
  font-size: 1.9rem;
  color: #666666;
}

.content-img {
  width: 100%;
  margin-top: 1rem;
}

.content-desc {
  font-size: 1.5rem;
  margin-top: 1rem;
  color: #666666;
  letter-spacing: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/components/SolutionContent.vue